import { Platform, StyleSheet, ViewStyle } from 'react-native'
import React, { RefObject } from 'react'
import { TextInput } from 'react-native-gesture-handler'
import { BottomSheetTextInput } from '@gorhom/bottom-sheet'
import { fontFamily } from '../../theme'
import { DS } from '../../design-system'

type ChatTextInputProps = React.ComponentProps<typeof TextInput> &
  React.ComponentProps<typeof BottomSheetTextInput> & {
    style: ViewStyle
    textInputRef: RefObject<TextInput | null>
  }

const GameCodeTextInput = (props: ChatTextInputProps) => {
  return <BottomSheetTextInput ref={props.textInputRef} {...props} style={[styles.input, props.style]} />
}

export default GameCodeTextInput

const styles = StyleSheet.create({
  input: {
    flex: 1,
    alignSelf: 'center',

    paddingLeft: 16,
    paddingRight: 12,

    height: 48,
    borderRadius: 48,
    borderWidth: 1,
    borderColor: DS.palette['Global/Black'],

    color: DS.palette['Global/Black'],
    backgroundColor: DS.palette['Brand/Cream'],

    fontSize: 16,
    fontFamily: fontFamily.GTAmericaStandardRegular
  }
})
